import { Accordion } from "./Accordion";
import { CheckIcon } from "lucide-react";
import { TOMOS } from "../data/content";
export function Tomos() {
  return <section className="px-5 pt-8" data-id="element-236" data-mp="13d92hv05uuj8">
      <div className="space-y-3" data-id="element-237" data-mp="1h32rqefkvgth">
        {TOMOS.map((tomo, idx) => <Accordion key={tomo.title} title={`${tomo.emoji} ${tomo.title}`} defaultOpen={idx === 0} data-id="element-238" data-mp="1h4dwohkreum6" data-mpi={idx}>
            <ul className="space-y-2.5" data-id="element-239" data-mp="1r0qv1sr91wn9">
              {tomo.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-240" data-mp="1m2fmdlcoxs6m">
                  <CheckIcon size={18} className="mt-0.5 flex-shrink-0 text-blue-600" data-id="element-241" data-mp="1m49xk7y5u5xi" />
                  <span className="text-sm leading-relaxed text-gray-700" data-id="element-242" data-mp="1w03iofpy37qw">
                    {item}
                  </span>
                </li>)}
            </ul>
          </Accordion>)}
      </div>
    </section>;
}